<template>

	<div>
	
		<agile :options="options">
		
			<img class="slide" v-for="(image, index) in images" :key="image" :src="image" v-on:click="$emit('imageId', index)"></img>
			
			<template slot="prevButton">&nbsp;</template>
			<template slot="nextButton">&nbsp;</template>
			
		</agile>
		
	</div>
	
</template>



<script>

	import { VueAgile } from 'vue-agile';
	

	export default {

		data: () => ({
			
			xx: 0,
			
			options: {
				dots: false,
				centerMode: true,
				navButtons: false,
			responsive: [{
					breakpoint: 400,
					settings: {
						slidesToShow: 2,
						navButtons: false,
					}
				},{
					breakpoint: 600,
					settings: {
						slidesToShow: 3,
						navButtons: true,
					}					
				},{
					breakpoint: 800,
					settings: {
						slidesToShow: 4,
						navButtons: true,
					}
				},{				
					breakpoint: 1000,
					settings: {
						slidesToShow: 5,
						navButtons: true,
					}
				},{				
					breakpoint: 1200,
					settings: {
						slidesToShow: 6,
						navButtons: true,
					}
				}]
			}

		}),
		
		
		props: ['images'],
		
		
		components: {
			agile: VueAgile,
		}
		
		
	}

</script>



<style lang="scss">

	.agile {

		&__nav-button {
			background: transparent;
			border: none;
			color: #fff;
			cursor: pointer;
			font-size: 24px;
			height: 100%;
			position: absolute;
			top: 0;
			transition-duration: .3s;
			width: 80px;
		
			&:hover {
				background-color: rgba(#000, .5);
				opacity: 1;
			}
			
			&--prev {
				left: 0
			}
			
			&--next {
				right: 0
			}
			
		}
		
		&__dots {
			bottom: 10px;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
		}
			
		&__dot {
			margin: 0 10px;
		
			button {
				background-color: transparent;
				border: 1px solid #fff;
				border-radius: 50%;
				cursor: pointer;
				display: block;
				height: 10px;
				font-size: 0;
				line-height: 0;
				margin: 0;
				padding: 0;
				transition-duration: .3s;
				width: 10px;
				}
				
			&--current,
			&:hover {
				button {
					background-color: #fff
				}
			}
			
		}
		
		&__nav-button {
				width: 40px;
				padding: 0;
				background-image: url("../assets/arrow.svg");
				background-position: right center;
				background-repeat: no-repeat;
				background-size: 60%;
				opacity: 0.2;
				
			&:hover {
				background-color: transparent;
				opacity: 1;
			}

			&--prev { 
				left: -40px;
				transform: scale(1);
			}
			
			&--next { 
				right: -40px;
				transform: scale(-1);				
			}
			
		}
		
	}	

	.slide {
		align-items: center;
		color: #fff;
		object-fit: contain;
		display: flex;
		justify-content: center;
		height: 150px;
		cursor: pointer;
	}

</style>
